import React, { useState } from 'react';
import { clients } from '../data/clients';
import SectionHeading from '../components/SectionHeading';

// One client: logo on a white panel, institute name underneath (when one is set).
function Logo({ item }) {
  const [failed, setFailed] = useState(false);
  const hasImage = item.logo && !failed;
  return (
    <figure className={`logoCard ${item.label ? '' : 'logoCard--plain'}`}>
      <div className="logoCard__panel">
        {hasImage
          ? <img src={item.logo} alt={item.label || item.name} loading="eager" decoding="async" onError={() => setFailed(true)} />
          : <span>{item.name}</span>}
      </div>
      {item.label && <figcaption>{item.label}</figcaption>}
    </figure>
  );
}

// 5 or more logos scroll slowly (the list is repeated once for a seamless loop).
// With fewer logos a centred static row is used, so there are no gaps in the animation.
export default function Clients() {
  const animate = clients.items.length >= 5;
  const list = animate ? [...clients.items, ...clients.items] : clients.items;
  return (
    <section className="section">
      <div className="container">
        <SectionHeading row title={clients.title} text={clients.text} />
      </div>
      <div className={`marquee ${animate ? '' : 'marquee--static'}`} aria-label="Our clients">
        <div className="marquee__track">
          {list.map((c, i) => (<Logo key={i} item={c} />))}
        </div>
      </div>
    </section>
  );
}
